module.exports = __webpack_public_path__ + "img/no-data.6fe9fad6.svg";